import { render, staticRenderFns } from "./StandardStepCalculation.component.vue?vue&type=template&id=460ad100&"
import script from "./StandardStepCalculation.component.vue?vue&type=script&lang=js&"
export * from "./StandardStepCalculation.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports